/**
 * EventBus - Sistema de Eventos Desacoplado para Detectimáticas
 * Permite comunicar módulos y componentes de forma reactiva y escalable
 */

class EventBusManager {
    constructor() {
        this.listeners = new Map();
    }

    /**
     * Suscribir un callback a un evento
     * @param {string} event 
     * @param {Function} callback 
     */
    on(event, callback) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, []);
        }
        this.listeners.get(event).push(callback);
    }

    /**
     * Cancelar la suscripción de un callback a un evento
     * @param {string} event 
     * @param {Function} callback 
     */
    off(event, callback) {
        if (!this.listeners.has(event)) return;
        const callbacks = this.listeners.get(event).filter(cb => cb !== callback);
        this.listeners.set(event, callbacks);
    }

    /**
     * Emitir un evento notificando a todos los suscriptores
     * @param {string} event 
     * @param {any} data 
     */
    emit(event, data) {
        if (!this.listeners.has(event)) return;
        this.listeners.get(event).forEach(callback => {
            try {
                callback(data);
            } catch (err) {
                console.error(`❌ Error en listener de EventBus [${event}]:`, err);
            }
        });
    }

    /**
     * Suscribir un callback de un solo uso
     * @param {string} event 
     * @param {Function} callback 
     */
    once(event, callback) {
        const onceWrapper = (data) => {
            callback(data);
            this.off(event, onceWrapper);
        };
        this.on(event, onceWrapper);
    }
}

export const EventBus = new EventBusManager();

// Exponer en la jerarquía global de Detectimáticas
if (typeof window !== 'undefined') {
    window.Detectimaticas = window.Detectimaticas || {};
    window.Detectimaticas.EventBus = EventBus;
    window.EventBus = EventBus;
}
